import { Component, DOCUMENT, inject, Inject, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LandingBackground } from './components/wrappers/landing-background/landing-background';
import { ErrorPopup } from "./components/popup/error-popup/error-popup";
import { InfoPopup } from "./components/popup/info-popup/info-popup";
import { NotificationService } from './core/notifications.service';
import { AsyncPipe } from '@angular/common';
import { Snackbar } from './components/snackbar/snackbar';
import { ImagePreviewComponent } from "./components/image-preview/image-preview";
import { LoadingService } from './core/loading.service';
import { isRtlLocale } from './core/locale-direction';
/**/
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LandingBackground, ErrorPopup, InfoPopup, AsyncPipe, Snackbar, ImagePreviewComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected loadingService = inject(LoadingService);
  
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    @Inject(DOCUMENT) private document: Document,
    public notify: NotificationService
  ) {    
    const isRtl = isRtlLocale(this.locale); //
    this.document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  }
}
